export const auth_host =
  process.env.NODE_ENV === 'production'
    ? 'https://itonecsp-auth.cloudcentric.app'
    : 'https://itonecsp-dev.cloudcentric.app/auth-api';
export const ccp_host =
  process.env.NODE_ENV === 'production'
    ? 'https://itonecsp-ccp.cloudcentric.app'
    : 'https://itonecsp-dev.cloudcentric.app/ccp-api';
    //: 'http://localhost:8082';
export const beacon_host =
  process.env.NODE_ENV === 'production'
    ? 'https://itonecsp-beacon.cloudcentric.app'
    : 'https://itonecsp-dev.cloudcentric.app/beacon-api';
export const msal_config = {
  auth: {
    clientId:
      process.env.NODE_ENV === 'production'
        ? //? '0ee6e918-490c-435d-a9df-ce0d367b2f1b'
          'b5b39424-29ab-4083-9974-0df0e0e9134c'
        : '5fe8aa60-0472-4143-8d5f-620e6fa8af01',
    //authority: 'https://login.microsoftonline.com/common',
    authority:
      process.env.NODE_ENV === 'production'
        ? //? 'https://login.microsoftonline.com/f3211d0e-125b-42c3-86db-322b19a65a22'
          'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb'
        //: 'https://login.microsoftonline.com/d2562e2c-6ab4-40fa-be65-72b155134390',
        : 'https://login.microsoftonline.com/common',
    redirectUri:
      process.env.NODE_ENV === 'production'
        ? 'https://itonecsp.cloudcentric.app'
        : 'https://itonecsp-dev.cloudcentric.app',
        // : 'http://localhost:8081',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};
